export const BACKGROUND_COLORS = {
    MINT: "mint",
    PLUM: "plum",
} as const;

export type BACKGROUND_COLOR = typeof BACKGROUND_COLORS[keyof typeof BACKGROUND_COLORS];
